import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';
import { categoryMap } from '@/mocks/categories';

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <article className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-background-300/60 transition-all duration-300">
      <Link to={`/article/${article.slug}`} className="block cursor-pointer">
        <div className="aspect-[16/9] overflow-hidden bg-background-200">
          <img
            src={article.imageUrl}
            alt={article.title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
        </div>
      </Link>
      <div className="p-5">
        <div className="flex items-center gap-3 mb-3">
          <Link
            to={`/category/${article.category}`}
            className="text-xs font-label bg-secondary-100 text-secondary-700 px-2.5 py-1 rounded-full hover:bg-secondary-200 transition-colors cursor-pointer whitespace-nowrap"
          >
            {categoryMap[article.category] || article.category}
          </Link>
          <span className="text-xs text-foreground-500">{article.date}</span>
          <span className="text-xs text-foreground-500">{article.readTime}</span>
        </div>
        <Link to={`/article/${article.slug}`} className="block cursor-pointer">
          <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
            {article.title}
          </h3>
        </Link>
        <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-3">
          {article.excerpt}
        </p>
        <div className="flex items-center justify-between">
          <span className="text-xs text-foreground-500">{article.author}</span>
          <Link
            to={`/article/${article.slug}`}
            className="text-xs font-label text-primary-600 hover:text-primary-700 transition-colors flex items-center gap-1 cursor-pointer whitespace-nowrap"
          >
            阅读全文 <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </article>
  );
}